import React from 'react';
import { useChatContext } from '@copilotkit/react-ui';

// import Icon from '@components/shared/icon/Icon';

export const SidebarHeader = () => {
  const { open, setOpen } = useChatContext();

  return (
    <div className="sidebar-header rounded-t-lg bg-card-foreground flex items-center justify-between gap-3 px-4 py-4">
      <figure className="flex items-center gap-7 mt-2">
        <img src="/images/avatar.png" alt="Alia" className="h-17 w-17" />
        <figcaption className="font-normal">
        I'm <span className="font-bold">Alia,</span> your personal assistant
        </figcaption>
      </figure>
      <button
        onClick={() => setOpen(false)}
        className="bg-card-foreground absolute top-2 right-2 flex size-10 shrink-0 items-center justify-center rounded-full shadow-[0_0_40px_0_rgba(0,0,0,0.1)] xl:hidden"
      >
        <img src="/images/close.svg" className="shrin-0 size-6" />
      </button>
    </div>
  );
};
